import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const InvoiceViewSidebarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S16};
  width: 218px;
  position: sticky;
  top: 0;
`
